export default __webpack_public_path__ + "f93ecfc5ee489b7bbea11c773827efd4.jpeg";